const state = {
  isLoading: true,
  isLoadRestaurantData: true,
  userDineInMethod: "dine in", // possible value: dine in / pick up (delivery use this value too)
  reservation: {
    adult: 0,
    date: "",
    formatedDate: "",
    kids: 0,
    promoCode: "",
    date: "",
    selectedPackages: [],
    startTime: "",
    specialRequest: "",
    occasion: "",
    serviceType: " ",
    paymentMethod: "card", // if booking is require cc, this state have 2 possible value: card / promptpay
    distanceToRestaurant: null,
    loadingPartialCharge: false,
    partialCharge: null
  },
  address: {
    name: "default",
    placeName: "",
    detail: "",
    lat: "",
    lon: "",
    noteForDriver: ""
  },
  distanceToRestaurant: "",
  confirmPreferMenuClicked: true,
  BookingValidationErrors: [],
  user: {
    id: "",
    name: "",
    email: "",
    phone: "",
    phoneV2: "",
    callingCode: "+66"
  },
  recordGuest: [],
  userSignedIn: false,
  anyAvailableDate: true,
  disabledDate: {},
  acceptTNC: true,
  runFormValidator: "pending",
  cc: {
    token: "",
    name: "",
    number: "",
    expirationMonth: "",
    expirationYear: "",
    securityCode: ""
  },
  allPackages: [],
  occasionList: [],
  tnc: "",
  step: 0,
  time: "",
  timePanel: [],
  isBigGroupBooking: false,
  restaurant: {}
};
export default state;
